/**
 * Created by xiehan on 2019/01/03.
 */

import Logic from '../logic-base'

const workFlowRoleManageBiz = new Logic()

workFlowRoleManageBiz.getAllGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.workFlowRoleManage.getAllGroup,
    data: data
  })
}

workFlowRoleManageBiz.findUsersByGroupId = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.workFlowRoleManage.findUsersByGroupId,
    data: data
  }, false, true)
}

workFlowRoleManageBiz.addUserToRole = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.workFlowRoleManage.addUserToRole,
    data: data
  })
}

workFlowRoleManageBiz.deleteRole = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.workFlowRoleManage.deleteRole,
    data: data
  })
}

export default workFlowRoleManageBiz
